import React from "react";
import styled, { css, keyframes } from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

export const G = {
  teal: COLORS.BTN_GREEN || "#00838C",
  tealLight: "#E6F4F5",
  tealMid: "#B2DDE0",
  tealDark: "#006870",
  tealGhost: "#F0FAFB",
  navy: COLORS.COLOR_DARK || "#293461",
  navyLight: "#3D4A82",
  slate800: "#1E293B",
  slate700: "#334155",
  slate600: "#475569",
  slate500: "#64748B",
  slate400: "#94A3B8",
  slate300: "#CBD5E1",
  slate200: COLORS.BORDER_GREY || "#E1E3EE",
  slate100: COLORS.TABLE_GREY_CELL || "#F4F6FF",
  slate50: "#F8FAFC",
  white: "#FFFFFF",
  red: COLORS.REMOVE_RED || "#FF3C3C",
  redDark: COLORS.LOGOUT_RED || "#D91B1B",
  redLight: "#FFF1F1",
  amber: "#F59E0B",
  amberLight: "#FFFBEB",
  emerald: "#10B981",
  emeraldLight: "#ECFDF5",
  indigo: "#4F46E5",
  indigoLight: "#EEF2FF",
  shadowSm: "0 1px 3px rgba(41,52,97,0.08), 0 1px 2px rgba(41,52,97,0.04)",
  shadowMd: "0 4px 12px rgba(41,52,97,0.10), 0 2px 4px rgba(41,52,97,0.06)",
  shadowLg: "0 10px 30px rgba(41,52,97,0.12), 0 4px 8px rgba(41,52,97,0.06)",
};

export const Ico = ({
  d,
  size = 16,
  color = "currentColor",
  vb = "0 0 24 24",
  sw = "2",
  fill = "none",
  children,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox={vb}
    fill={fill}
    stroke={color}
    strokeWidth={sw}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    {...rest}
  >
    {d ? <path d={d} /> : children}
  </svg>
);

export const IcoLayers = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <polygon points="12 2 20 7 20 17 12 22 4 17 4 7 12 2" />
    <polyline points="12 12 20 7" />
    <polyline points="12 12 12 22" />
    <polyline points="12 12 4 7" />
  </Ico>
);
export const IcoLock = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </Ico>
);
export const IcoClock = ({ size = 14, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </Ico>
);
export const IcoSearch = ({ size = 14, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </Ico>
);
export const IcoFile = ({ size = 13, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <polyline points="13 2 13 9 20 9" />
  </Ico>
);
export const IcoChevronDown = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <polyline points="6 9 12 15 18 9" />
  </Ico>
);
export const IcoChevronRight = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <polyline points="9 18 15 12 9 6" />
  </Ico>
);
export const IcoChevronLeft = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <polyline points="15 18 9 12 15 6" />
  </Ico>
);
export const IcoPlus = ({ size = 13, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </Ico>
);
export const IcoUpload = ({ size = 13, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <polyline points="16 16 12 12 8 16" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </Ico>
);
export const IcoMenu = ({ size = 18, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </Ico>
);
export const IcoX = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </Ico>
);
export const IcoMoreVertical = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color} fill={color} sw="0">
    <circle cx="12" cy="5" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="12" cy="19" r="1.5" />
  </Ico>
);
export const IcoArrowUp = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </Ico>
);
export const IcoArrowDown = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <polyline points="19 12 12 19 5 12" />
  </Ico>
);
export const IcoEdit = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </Ico>
);
export const IcoTrash = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </Ico>
);
export const IcoFolder = ({ size = 13, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </Ico>
);
export const IcoFolderPlus = ({ size = 13, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    <line x1="12" y1="11" x2="12" y2="17" />
    <line x1="9" y1="14" x2="15" y2="14" />
  </Ico>
);
export const IcoMove = ({ size = 12, color = "currentColor" }) => (
  <Ico size={size} color={color}>
    <polyline points="5 9 2 12 5 15" />
    <polyline points="19 9 22 12 19 15" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </Ico>
);
export const SidebarCollapseIcon = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <polyline points="15 9 12 12 15 15" />
  </Ico>
);
export const SidebarExpandIcon = ({ size = 15, color = "currentColor" }) => (
  <Ico size={size} color={color} sw="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <polyline points="12 9 15 12 12 15" />
  </Ico>
);

export const fadeIn = keyframes`from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}`;
const slideDown = keyframes`from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}`;
const dropdownAnim = keyframes`from{opacity:0;transform:translateY(-8px) scale(0.96)}to{opacity:1;transform:translateY(0) scale(1)}`;
export const scaleIn = keyframes`from{opacity:0;transform:scale(0.96)}to{opacity:1;transform:scale(1)}`;
export const overlayIn = keyframes`from{opacity:0}to{opacity:1}`;
const slideInFromRight = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }`;
const slideOutToRight = keyframes`
  from { transform: translateX(0);    opacity: 1; }
  to   { transform: translateX(100%); opacity: 0; }`;
const slideInFromLeft = keyframes`
  from { transform: translateX(-40px); opacity: 0; }
  to   { transform: translateX(0);     opacity: 1; }`;
const slideOutToLeft = keyframes`
  from { transform: translateX(0);     opacity: 1; }
  to   { transform: translateX(-40px); opacity: 0; }`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(26, 35, 56, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: ${overlayIn} 0.2s ease;
`;
export const ModalCard = styled.div`
  background: ${G.white};
  border-radius: 14px;
  box-shadow: ${G.shadowLg};
  width: min(480px, 100%);
  animation: ${scaleIn} 0.2s ease;
  overflow: hidden;
`;
export const ModalHeader = styled.div`
  display: flex;
  gap: 13px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid ${G.slate100};
  align-items: flex-start;
`;
export const ModalAccent = styled.div`
  width: 4px;
  min-height: 40px;
  border-radius: 4px;
  background: ${G.teal};
  flex-shrink: 0;
  margin-top: 2px;
`;
export const ModalHeaderContent = styled.div`
  flex: 1;
`;
export const ModalTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${G.navy};
  font-family: ${theme.fonts.primaryFontSemiBold};
  margin: 0 0 5px;
`;
export const ModalSubtitle = styled.p`
  font-size: 12px;
  color: ${G.slate500};
  font-family: ${theme.fonts.primaryFontRegular};
  line-height: 1.6;
  margin: 0;
`;
export const ModalCloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  &:hover {
    background: ${G.slate100};
  }
`;
export const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
export const UploadFilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
export const UploadSearchWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 160px;
`;
export const UploadSearchIcon = styled.div`
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
`;
export const UploadSearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 32px;
  border-radius: 8px;
  border: 1.5px solid ${G.slate200};
  background: ${G.white};
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12.5px;
  color: ${G.slate800};
  outline: none;
  box-sizing: border-box;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  &::placeholder {
    color: ${G.slate300};
  }
  &:focus {
    border-color: ${G.teal};
    box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.1);
  }
`;
export const UploadSummaryPill = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: ${G.tealLight};
  color: ${G.tealDark};
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  white-space: nowrap;
`;
export const UploadSourceRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;
export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid ${G.slate100};
  background: ${G.slate50};
`;
export const ClearSearchBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  &:hover {
    background: ${G.slate100};
  }
`;
export const UploadDocInfo = styled.div`
  flex: 1;
  min-width: 0;
`;
export const UploadDocName = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12.5px;
  color: ${COLORS.COLOR_DARK};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
`;
export const UploadDocMeta = styled.div`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 10.5px;
  color: ${G.slate400};
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;
export const UploadMetaDot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: ${G.slate300};
  display: inline-block;
  flex-shrink: 0;
`;
export const UploadPagesBadge = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 5px;
  background: ${G.slate100};
  color: ${G.slate600};
`;
export const UploadSourceTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 7px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10.5px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
  border: 1px solid ${(p) => p.$border};
  white-space: nowrap;
  flex-shrink: 0;
`;
export const UploadPickedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 7px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10.5px;
  background: ${G.tealLight};
  color: ${G.tealDark};
  white-space: nowrap;
  flex-shrink: 0;
`;
export const UploadExpandToggle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 7px;
  border: 1.5px solid ${G.slate200};
  background: ${G.white};
  display: grid;
  place-items: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  transform: ${(p) => (p.$expanded ? "rotate(180deg)" : "rotate(0deg)")};
`;
export const UploadPageInputWrap = styled.div`
  padding: 12px 14px 14px 41px;
  background: ${G.slate50};
  border-top: 1px dashed ${G.slate200};
  display: flex;
  flex-direction: column;
  gap: 7px;
`;
export const UploadPageInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
`;
export const UploadPageRangeField = styled.input`
  flex: 1;
  min-width: 130px;
  max-width: 220px;
  padding: 7px 11px;
  border-radius: 8px;
  border: 1.5px solid ${(p) => (p.$error ? G.red : G.slate200)};
  background: ${G.white};
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12.5px;
  color: ${G.slate800};
  outline: none;
  box-sizing: border-box;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  &::placeholder {
    color: ${G.slate300};
  }
  &:focus {
    border-color: ${(p) => (p.$error ? G.red : G.teal)};
    box-shadow: 0 0 0 3px
      ${(p) => (p.$error ? "rgba(255,60,60,0.1)" : "rgba(0,131,140,0.1)")};
  }
`;
export const UploadDocListBox = styled.div`
  border: 1.5px solid ${G.slate200};
  border-radius: 12px;
  overflow: hidden;
  max-height: 360px;
  overflow-y: auto;
  background: ${G.white};
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 4px;
  }
`;
export const ChipDotSpan = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
`;
export const uploadBtnBase = css`
  padding: 7px 13px;
  border-radius: 8px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  border: 1.5px solid transparent;
`;

export const UploadApplyBtn = styled.button`
  ${uploadBtnBase}
  background: ${G.teal};
  color: #fff;
  border-color: ${G.tealDark};
  &:hover {
    background: ${G.tealDark};
  }
`;
export const UploadQuickBtn = styled.button`
  ${uploadBtnBase}
  background: ${G.white};
  color: ${G.navy};
  border-color: ${G.slate200};
  &:hover {
    border-color: ${G.navy};
    background: ${G.slate100};
  }
`;
export const UploadClearBtn = styled.button`
  ${uploadBtnBase}
  background: transparent;
  color: ${G.slate500};
  border-color: ${G.slate200};
  &:hover {
    border-color: ${G.red};
    color: ${G.red};
    background: ${G.redLight};
  }
`;
export const RangeErrorText = styled.span`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 11px;
  color: ${G.red};
`;
export const PickedLabelText = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  color: ${G.tealDark};
`;
export const UploadDocItem = styled.div`
  border-bottom: 1px solid ${G.slate100};
  &:last-child {
    border-bottom: none;
  }
`;
export const UploadDocRow = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px 14px;
  background: ${G.white};
  cursor: pointer;
  transition: background 0.12s ease;
  &:hover {
    background: ${G.slate50};
  }
`;
export const UploadCheckBox = styled.button`
  width: 18px;
  height: 18px;
  border-radius: 5px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border: 2px solid ${(p) => (p.$on || p.$partial ? G.teal : G.slate200)};
  background: ${(p) => (p.$on ? G.teal : "transparent")};
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: ${G.teal};
    background: ${(p) => (p.$on ? G.tealDark : G.tealLight)};
  }
`;
export const UploadPartialDash = styled.div`
  height: 2px;
  width: 8px;
  background: ${G.teal};
  border-radius: 1px;
`;
export const UploadSourceChip = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  font-weight: ${(p) => (p.$on ? 700 : 500)};
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1.5px solid ${(p) => (p.$on ? p.$dot || G.teal : G.slate200)};
  background: ${(p) => (p.$on ? p.$bg : G.white)};
  color: ${(p) => (p.$on ? p.$fg : G.slate500)};
  &:hover {
    border-color: ${(p) => p.$dot || G.teal};
    color: ${(p) => p.$fg};
    background: ${(p) => p.$bg};
  }
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
  animation: ${fadeIn} 0.2s ease;
`;
export const EmptyText = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${G.slate700};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const ModalCancelBtn = styled.button`
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 12.5px;
  border: 1.5px solid ${G.slate200};
  background: ${G.white};
  color: ${G.slate700};
  cursor: pointer;
  transition: all 0.15s;
  font-family: ${theme.fonts.primaryFontSemiBold};
  &:hover {
    border-color: ${G.slate400};
    background: ${G.slate50};
  }
`;
export const ModalCreateBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 12.5px;
  border: none;
  background: ${G.teal};
  color: ${G.white};
  cursor: pointer;
  transition: all 0.15s;
  font-family: ${theme.fonts.primaryFontSemiBold};
  box-shadow: 0 2px 6px rgba(0, 131, 140, 0.3);
  &:hover {
    background: ${G.tealDark};
    box-shadow: 0 4px 12px rgba(0, 131, 140, 0.4);
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
`;
export const FieldError = styled.p`
  font-size: 11px;
  color: ${G.red};
  font-family: ${theme.fonts.primaryFontRegular};
  margin: 0;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
export const FieldLabel = styled.label`
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: ${G.slate500};
  font-family: ${theme.fonts.primaryFontSemiBold};
  text-transform: uppercase;
`;
export const BundleCheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid ${G.slate200};
  border-radius: 8px;
  padding: 6px;
  background: ${G.slate50};
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 2px;
  }
`;
export const BundleCheckItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.12s;
  background: ${({ $selected }) => ($selected ? G.tealLight : G.white)};
  border: 1px solid
    ${({ $selected }) => ($selected ? G.tealMid : "transparent")};
  &:hover {
    background: ${({ $selected }) => ($selected ? G.tealLight : G.slate100)};
  }
`;
export const FieldInput = styled.input`
  padding: 9px 13px;
  border-radius: 8px;
  font-size: 13px;
  border: 1.5px solid ${({ $error }) => ($error ? G.red : G.slate200)};
  outline: none;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
  background: ${G.slate50};
  transition:
    border-color 0.15s,
    box-shadow 0.15s,
    background 0.15s;
  &:focus {
    border-color: ${({ $error }) => ($error ? G.red : G.teal)};
    box-shadow: 0 0 0 3px
      ${({ $error }) =>
    $error ? "rgba(255,60,60,0.1)" : "rgba(0,131,140,0.12)"};
    background: ${G.white};
  }
  &::placeholder {
    color: ${G.slate300};
  }
`;
export const FieldHint = styled.p`
  font-size: 11.5px;
  color: ${G.slate500};
  font-family: ${theme.fonts.primaryFontRegular};
  margin: 0;
  line-height: 1.5;
`;
export const StampExample = styled.code`
  background: ${G.tealLight};
  color: ${G.teal};
  border: 1px solid ${G.tealMid};
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-family: "Courier New", monospace;
`;

export const Shell = styled.div`
  display: flex;
  background: #eef3f7;
  height: calc(100vh - 140px);
  border: 1px solid ${G.slate200};
  border-radius: 12px;
  overflow: hidden;
  font-family: ${theme.fonts.primaryFontRegular};
  position: relative;
  @media (max-width: 768px) {
    height: calc(100vh - 72px);
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
  }
`;
export const Overlay = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(41, 52, 97, 0.45);
    z-index: 40;
    backdrop-filter: blur(3px);
    animation: ${overlayIn} 0.2s ease;
  }
`;
export const Sidebar = styled.nav`
  width: ${({ $collapsed }) => ($collapsed ? "48px" : "308px")};
  flex-shrink: 0;
  background: #fbfdff;
  border-right: 1px solid ${G.slate200};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 0;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 2px;
  }
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 50;
    width: min(300px, 85vw);
    box-shadow: ${G.shadowLg};
    transform: ${({ $open }) =>
    $open ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 0.26s cubic-bezier(0.4, 0, 0.2, 1), width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 10px 16px;
  border-bottom: 1px solid ${G.slate100};
  margin-bottom: 4px;
  flex-shrink: 0;
  min-height: 44px;
  box-sizing: border-box;
`;

export const SidebarTitle = styled.h4`
  font-size: 11px;
  font-weight: 700;
  color: ${G.slate500};
  letter-spacing: 0.6px;
  text-transform: uppercase;
  font-family: ${theme.fonts.primaryFontSemiBold};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SidebarToggleBtn = styled.button`
  background: transparent;
  border: 1px solid ${G.slate200};
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${G.slate600};
  flex-shrink: 0;
  transition: all 0.15s ease;
  padding: 0;
  &:hover {
    background: ${G.tealGhost};
    color: ${G.teal};
    border-color: ${G.tealMid};
  }
`;

export const CollapsedSidebarBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
  width: 100%;
  gap: 16px;
`;
export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f6f8fb;
  min-width: 0;
`;
export const ViewportWrap = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
export const listPhaseCss = {
  idle: css`
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
  `,
  entering: css`
    transform: translateX(-40px);
    opacity: 0;
    pointer-events: none;
    animation: ${slideOutToLeft} 0.32s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  `,
  visible: css`
    transform: translateX(-40px);
    opacity: 0;
    pointer-events: none;
  `,
  exiting: css`
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
    animation: ${slideInFromLeft} 0.32s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  `,
};
export const ListPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  ${({ $phase }) => listPhaseCss[$phase] || listPhaseCss.idle}
`;
export const viewerPhaseCss = {
  entering: css`
    animation: ${slideInFromRight} 0.32s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  `,
  visible: css`
    transform: translateX(0);
    opacity: 1;
  `,
  exiting: css`
    animation: ${slideOutToRight} 0.32s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  `,
};
export const ViewerPane = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: ${G.white};
  z-index: 10;
  ${({ $phase }) => viewerPhaseCss[$phase] || ""}
`;
export const NavSection = styled.div`
  padding: 8px 10px;
  border-bottom: 1px solid #edf1f6;
  &:last-of-type {
    border-bottom: none;
  }
`;
export const NavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 11px;
  cursor: pointer;
  transition: background 0.12s;
  background: ${({ $active }) => ($active ? G.tealLight : "transparent")};
  border: 1px solid ${({ $active }) => ($active ? G.tealMid : "transparent")};
  border-left: 3px solid ${({ $active }) => ($active ? G.teal : "transparent")};
  border-radius: 7px;
  &:hover {
    background: ${({ $active }) => ($active ? G.tealLight : G.slate50)};
  }
`;
export const ChevronWrap = styled.span`
  color: ${G.slate400};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  width: 14px;
`;
export const NavIconWrap = styled.span`
  display: flex;
  align-items: center;
  width: 18px;
  flex-shrink: 0;
`;
export const NavLabel = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active }) => ($active ? G.teal : "#293461")};
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontSemiBold : theme.fonts.primaryFontRegular};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const NavBadge = styled.span`
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  background: ${({ $active }) => ($active ? G.tealMid : G.slate100)};
  color: ${({ $active }) => ($active ? G.tealDark : G.slate500)};
  font-family: ${theme.fonts.primaryFontSemiBold};
  min-width: 24px;
  text-align: center;
`;
export const NavAddBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 4px;
  &:hover {
    background: ${G.tealLight};
  }
`;
export const SubNav = styled.div`
  padding: ${({ $flat }) => ($flat ? "3px 0 2px 0" : "6px 0 2px 32px")};
  animation: ${slideDown} 0.15s ease;
`;
export const SubNavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  font-size: 12px;
  color: ${({ $active }) => ($active ? G.teal : "#293461")};
  cursor: pointer;
  border-radius: 7px;
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontSemiBold : theme.fonts.primaryFontRegular};
  transition: all 0.12s;
  &:hover {
    background: ${G.tealLight};
    color: ${G.teal};
  }
`;
export const SubNavBadge = styled.span`
  font-size: 9.5px;
  background: ${G.slate100};
  color: ${G.slate500};
  padding: 1px 5px;
  border-radius: 8px;
  margin-left: auto;
`;
export const SubNavEmpty = styled.div`
  padding: 6px 8px;
  font-size: 11.5px;
  color: ${G.slate400};
  font-style: italic;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const AddSubFolderInline = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${G.teal};
  font-size: 11.5px;
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const SourceDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $source }) =>
    $source === "Claimant"
      ? G.amber
      : $source === "Respondent"
        ? G.indigo
        : G.emerald};
`;
export const BundleNavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px 6px 14px;
  cursor: pointer;
  transition: background 0.12s;
  background: ${({ $active }) => ($active ? G.tealLight : "transparent")};
  border: 1px solid ${({ $active }) => ($active ? G.tealMid : "transparent")};
  border-left: 3px solid ${({ $active }) => ($active ? G.teal : "transparent")};
  border-radius: 7px;
  margin-left: 2px;
  margin-right: 2px;
  &:hover {
    background: ${({ $active }) => ($active ? G.tealLight : G.slate50)};
  }
`;
export const BundleNavChevron = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  &:hover {
    background: ${G.slate200};
  }
`;
export const BundleNavContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1;
  min-width: 0;
`;
export const BundleNavIdChip = styled.span`
  font-size: 9.5px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  flex-shrink: 0;
  background: ${({ $active }) => ($active ? G.tealLight : G.slate100)};
  color: ${({ $active }) => ($active ? G.teal : G.slate500)};
  border: 1px solid ${({ $active }) => ($active ? G.tealMid : G.slate200)};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const BundleNavName = styled.span`
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $active }) => ($active ? G.teal : G.slate700)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontSemiBold : theme.fonts.primaryFontRegular};
`;
export const SubFolderNavList = styled.div`
  padding: 2px 0 4px 14px;
  animation: ${slideDown} 0.13s ease;
  position: relative;
  margin-left: 2px;
  &::before {
    content: "";
    position: absolute;
    left: 6px;
    top: 4px;
    bottom: 6px;
    width: 1px;
    background: ${G.slate200};
  }
`;
export const SubFolderNavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px 6px 4px;
  cursor: pointer;
  transition: background 0.12s;
  background: ${({ $active }) => ($active ? G.tealLight : "transparent")};
  border-left: 3px solid ${({ $active }) => ($active ? G.teal : "transparent")};
  margin-left: -3px;
  border-radius: 7px;
  &:hover {
    background: ${({ $active }) => ($active ? G.tealLight : G.slate50)};
  }
`;
export const SubFolderChevron = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  &:hover {
    background: ${G.slate200};
  }
`;
export const SubFolderNavContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;
export const SubFolderPrefixChip = styled.span`
  font-size: 9px;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 3px;
  flex-shrink: 0;
  background: ${({ $active }) => ($active ? G.tealLight : G.slate100)};
  color: ${({ $active }) => ($active ? G.teal : G.slate500)};
  border: 1px solid ${({ $active }) => ($active ? G.tealMid : G.slate200)};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const SubFolderName = styled.span`
  font-size: 11.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $active }) => ($active ? G.teal : G.slate600)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontSemiBold : theme.fonts.primaryFontRegular};
`;
export const TabNavList = styled.div`
  padding: 1px 0 4px 20px;
  animation: ${slideDown} 0.13s ease;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    left: 10px;
    top: 2px;
    bottom: 6px;
    width: 1px;
    background: ${G.slate200};
  }
`;
export const TabNavListFlat = styled.div`
  padding: 2px 0 4px 14px;
  animation: ${slideDown} 0.13s ease;
  position: relative;
  margin-left: 2px;
  &::before {
    content: "";
    position: absolute;
    left: 6px;
    top: 2px;
    bottom: 6px;
    width: 1px;
    background: ${G.slate200};
  }
`;
export const TabNavEmpty = styled.div`
  font-size: 11px;
  color: ${G.slate400};
  padding: 4px 6px;
  font-style: italic;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const TabNavRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  cursor: pointer;
  transition: all 0.12s;
  background: ${({ $active }) => ($active ? G.tealLight : "transparent")};
  border-left: 3px solid ${({ $active }) => ($active ? G.teal : "transparent")};
  margin-left: -3px;
  border-radius: 6px;
  &:hover {
    background: ${({ $active }) => ($active ? G.tealLight : G.slate50)};
  }
`;
export const TabNavIndent = styled.span`
  width: 10px;
  flex-shrink: 0;
`;
export const TabNavLabel = styled.span`
  flex: 1;
  font-size: 10.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $active }) => ($active ? G.teal : G.slate500)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontSemiBold : theme.fonts.primaryFontRegular};
`;
export const TabNavCount = styled.span`
  font-size: 9.5px;
  padding: 1px 5px;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? G.tealMid : G.slate100)};
  color: ${({ $active }) => ($active ? G.tealDark : G.slate500)};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const SidebarSummary = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: auto 8px 8px;
  padding: 10px;
  background: ${G.slate50};
  border: 1px solid ${G.slate100};
  border-radius: 10px;
`;
export const SidebarSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  strong {
    font-size: 16px;
    line-height: 1;
    color: ${G.navy};
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
  span {
    font-size: 10.5px;
    color: ${G.slate500};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: ${G.white};
  border-bottom: 1px solid ${G.slate200};
  gap: 14px;
  flex-wrap: wrap;
  box-shadow: 0 1px 0 rgba(41, 52, 97, 0.04);
  flex-shrink: 0;
  @media (max-width: 640px) {
    padding: 9px 12px;
  }
`;
export const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;
export const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: 640px) {
    width: 100%;
    justify-content: flex-start;
  }
`;
export const HamburgerBtn = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  align-items: center;
  &:hover {
    background: ${G.slate100};
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;
export const BackBtn = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
  &:hover {
    background: ${G.tealMid};
    border-color: ${G.teal};
  }
`;
export const PageIconBox = styled.div`
  width: 34px;
  height: 34px;
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  @media (max-width: 480px) {
    display: none;
  }
`;
export const PageTitleGroup = styled.div`
  min-width: 0;
`;
export const PageTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: min(620px, 58vw);
  @media (max-width: 768px) {
    max-width: calc(100vw - 150px);
    font-size: 14px;
  }
`;
export const PageSub = styled.div`
  font-size: 11.5px;
  color: ${G.slate400};
  margin-top: 1px;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const PrimaryBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 36px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  background: ${G.teal};
  border: none;
  border-radius: 7px;
  color: ${G.white};
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 2px 6px rgba(0, 131, 140, 0.3);
  white-space: nowrap;
  &:hover {
    background: ${G.tealDark};
    box-shadow: 0 4px 12px rgba(0, 131, 140, 0.38);
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
  span {
    @media (max-width: 420px) {
      display: none;
    }
  }
`;
export const SecondaryBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 36px;
  padding: 7px 13px;
  font-size: 12px;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  background: ${COLORS.BTN_GREEN};
  border: 1.5px solid ${COLORS.BTN_GREEN};
  border-radius: 7px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  span {
    @media (max-width: 420px) {
      display: none;
    }
  }
`;
export const FilterStrip = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 20px;
  background: ${G.white};
  border-bottom: 1px solid ${G.slate200};
  flex-wrap: wrap;
  flex-shrink: 0;
  @media (max-width: 640px) {
    padding: 7px 12px;
  }
`;
export const FilterLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${G.slate400};
  letter-spacing: 0.6px;
  text-transform: uppercase;
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
`;
export const FilterPills = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;
export const Pill = styled.button`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  cursor: pointer;
  transition: all 0.15s;
  border: 1.5px solid ${({ $active }) => ($active ? G.teal : G.slate200)};
  background: ${({ $active }) => ($active ? G.tealLight : G.white)};
  color: ${({ $active }) => ($active ? G.teal : G.slate500)};
  &:hover {
    border-color: ${G.teal};
    color: ${G.teal};
    background: ${G.tealLight};
  }
`;
export const SectionBar = styled.div`
  display: flex;
  align-items: baseline;
  gap: 9px;
  padding: 18px 24px 12px;
  flex-shrink: 0;
  @media (max-width: 640px) {
    padding: 10px 12px 7px;
  }
`;
export const SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const SectionMeta = styled.div`
  font-size: 11.5px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 3px;
  }
  @media (max-width: 640px) {
    padding: 0 10px 16px;
  }
`;
export const EmptyIconBox = styled.div`
  width: 56px;
  height: 56px;
  background: ${G.slate100};
  border: 1.5px solid ${G.slate200};
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;
export const EmptyHint = styled.div`
  font-size: 12px;
  color: ${G.slate400};
  margin-top: 5px;
  max-width: 300px;
  line-height: 1.65;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const CoreTableWrap = styled.div`
  background: ${G.white};
  border-radius: 10px;
  border: 1px solid ${G.slate200};
  box-shadow: ${G.shadowSm};
  animation: ${fadeIn} 0.2s ease;
  position: relative;
  /* Bounded scroll area so the <thead> can stick to the TOP of this box,
     not the top of the page. Adjust max-height to taste / viewport. */
  max-height: calc(100vh - 360px);
  min-height: 200px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${G.slate300};
  }
  table {
    min-width: 920px;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
export const Th = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 13px 14px;
  text-align: left;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${G.slate500};
  background: ${G.slate50};
  border-bottom: 1px solid ${G.slate200};
  box-shadow: 0 1px 0 ${G.slate200};
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;
export const CoreTr = styled.tr`
  border-bottom: 1px solid ${G.slate100};
  transition: background 0.12s ease;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${G.slate50};
  }
  &:hover td:first-child {
    box-shadow: inset 3px 0 0 ${G.teal};
  }
`;
export const Td = styled.td`
  padding: 14px;
  vertical-align: middle;
`;
export const DocRef = styled.span`
  font-size: 11px;
  color: ${G.teal};
  cursor: pointer;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  &:hover {
    text-decoration: underline;
  }
`;
export const DocNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  width: 230px;
  overflow: hidden;

  &:hover span {
    text-decoration: underline;
    color: ${G.teal};
  }
`;

export const DocName = styled.span`
  font-size: 12.5px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  line-height: 1.3;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;
export const DateLine = styled.div`
  font-size: 12px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const TimeLine = styled.div`
  font-size: 10.5px;
  color: ${G.slate400};
  margin-top: 1px;
`;
export const PageChip = styled.span`
  display: inline-block;
  padding: 2px 8px;
  background: ${G.slate100};
  color: ${G.slate700};
  font-size: 11px;
  font-weight: 600;
  border-radius: 5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const DimText = styled.span`
  color: ${G.slate400};
  font-size: 12px;
`;
export const OwnerBadge = styled.span`
  display: inline-block;
  padding: 2px 9px;
  background: ${G.slate100};
  color: ${G.slate600};
  font-size: 11px;
  font-weight: 600;
  border-radius: 5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const DeleteIconBtn = styled.button`
  width: 30px;
  height: 30px;
  background: ${G.white};
  border: 1px solid ${G.slate200};
  cursor: pointer;
  padding: 0;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s;
  &:hover {
    border-color: #fecaca;
    background: ${G.redLight};
  }
`;
export const MobileCardList = styled.div`
  display: none;
  flex-direction: column;
  gap: 7px;
  @media (max-width: 768px) {
    display: flex;
  }
`;
export const MobileDocCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 11px;
  background: ${G.white};
  border: 1px solid ${G.slate200};
  border-radius: 10px;
  padding: 11px 13px;
  cursor: pointer;
  box-shadow: ${G.shadowSm};
  transition: box-shadow 0.15s;
  animation: ${fadeIn} 0.2s ease;
  &:hover {
    box-shadow: ${G.shadowMd};
  }
`;
export const MobileDocIconBox = styled.div`
  width: 36px;
  height: 36px;
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const MobileDocBody = styled.div`
  flex: 1;
  min-width: 0;
`;
export const MobileDocName = styled.div`
  font-size: 12.5px;
  font-weight: 600;
  color: ${G.slate800};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const MobileDocMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 2px;
  font-size: 11px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const SBadgeWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const SBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const SBadgeDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  flex-shrink: 0;
`;
export const SPageRef = styled.span`
  font-size: 10.5px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const visibilityColor = ({ $visibility }) =>
  $visibility === "all"
    ? G.emerald
    : $visibility === "others"
      ? G.indigo
      : G.slate600;
export const visibilityBg = ({ $visibility }) =>
  $visibility === "all"
    ? G.emeraldLight
    : $visibility === "others"
      ? G.indigoLight
      : G.slate100;
export const VisibilityBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  color: ${visibilityColor};
  background: ${visibilityBg};
  border: 1px solid
    ${({ $visibility }) =>
    $visibility === "all"
      ? "#A7F3D0"
      : $visibility === "others"
        ? "#C7D2FE"
        : G.slate200};
  font-size: 10.5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const VisibilityControl = styled.select`
  min-height: 32px;
  padding: 6px 28px 6px 10px;
  border-radius: 7px;
  border: 1px solid ${G.slate200};
  background: ${G.white};
  color: ${G.slate700};
  font-size: 11.5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  cursor: pointer;
  outline: none;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  &:hover,
  &:focus {
    border-color: ${G.teal};
    box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.08);
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;
export const SideVisibilityDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${visibilityColor};
`;
export const BundlesWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: ${fadeIn} 0.2s ease;
  padding-top: 2px;
`;
export const BundleBlock = styled.div`
  background: ${G.white};
  border: 1px solid ${G.slate200};
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 1px 2px rgba(41, 52, 97, 0.05);
  animation: ${fadeIn} 0.2s ease;
`;
export const BundleHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;
export const BundleTitleSep = styled.span`
  color: ${G.slate300};
  font-size: 14px;
`;
export const BundleName = styled.span`
  color: ${G.navy};
  min-width: 0;
  line-height: 1.35;
`;
export const Crumb = styled.span`
  color: ${G.slate300};
  font-size: 13px;
  margin: 0 1px;
`;
export const CrumbPill = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${G.teal};
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  padding: 1px 9px;
  border-radius: 20px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const MetaDivider = styled.span`
  margin: 0 6px;
  color: ${G.slate200};
  &::before {
    content: "·";
  }
`;
export const MetaFilter = styled.span`
  font-size: 11px;
  color: ${G.slate400};
`;
export const ClearBtn = styled.button`
  background: none;
  border: none;
  padding: 0 2px;
  cursor: pointer;
  color: ${G.teal};
  font-size: 11px;
  text-decoration: underline;
  font-family: ${theme.fonts.primaryFontRegular};
  &:hover {
    color: ${G.tealDark};
  }
`;
export const AddSubFolderBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 32px;
  padding: 6px 11px;
  border-radius: 7px;
  border: 1px solid ${G.tealMid};
  background: ${G.tealLight};
  color: ${G.teal};
  cursor: pointer;
  transition: all 0.15s;
  font-size: 11.5px;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
  &:hover {
    background: ${G.tealMid};
    border-color: ${G.teal};
  }
  span {
    @media (max-width: 480px) {
      display: none;
    }
  }
`;
export const RenameInput = styled.input`
  border: 1.5px solid ${G.teal};
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 13px;
  outline: none;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${G.slate800};
  background: ${G.white};
  width: min(240px, 100%);
  box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.1);
`;
export const EmptyRowBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 24px 18px;
  font-size: 12.5px;
  color: ${G.slate400};
  font-style: italic;
  font-family: ${theme.fonts.primaryFontRegular};
  border-top: 1px solid ${G.slate100};
`;
export const SubFolderBlock = styled.div`
  margin: 12px 14px 14px;
  border: 1px solid ${G.slate200};
  border-radius: 10px;
  background: ${G.white};
  box-shadow: 0 1px 4px rgba(41, 52, 97, 0.06);
  position: relative;
  overflow: visible;

  &::before {
    content: "";
    position: absolute;
    left: -1px;
    top: 14px;
    bottom: 14px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    // background: ${G.teal};
    opacity: 0.5;
  }
`;
export const SubFolderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 10px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid ${G.slate200};
  gap: 10px;
  border-radius: 10px 10px 0 0;
`;
export const SfHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 1;
  min-width: 0;
`;
export const SfCodeChip = styled.span`
  font-size: 10.5px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 5px;
  background: ${G.tealLight};
  color: ${G.teal};
  border: 1px solid ${G.tealMid};
  flex-shrink: 0;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const SfName = styled.span`
  display: flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 600;
  color: ${G.navy};
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SfLabel = styled.span`
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${G.teal};
  font-family: ${theme.fonts.primaryFontSemiBold};
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 8px;
  flex-shrink: 0;
  white-space: nowrap;
`;
export const SfHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  @media (max-width: 520px) {
    width: 100%;
    justify-content: space-between;
  }
`;
export const SfMeta = styled.div`
  display: flex;
  align-items: center;
  font-size: 11.5px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
  @media (max-width: 480px) {
    display: none;
  }
`;
export const TableWrap = styled.div`
  position: relative;
  border-radius: 0 0 8px 8px;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${G.slate200};
    border-radius: 3px;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;
export const InnerTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 820px;
  table-layout: fixed;
`;
export const InnerTr = styled.tr`
  background: ${G.slate50};
`;
export const ColTh = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 11px 12px 11px 0;
  text-align: left;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${G.slate500};
  background: ${G.slate50};
  border-bottom: 1px solid ${G.slate200};
  box-shadow: 0 1px 0 ${G.slate200};
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
`;
export const TabSeparatorTd = styled.td`
  padding: 0;
  position: sticky;
  top: 37px; /* sits just under the ColTh header row */
  z-index: 1;
`;
export const TabSepInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 16px 8px 18px;
  background: #f8fafc;
  border-top: 1px solid ${G.slate200};
  border-bottom: 1px solid ${G.slate200};
`;
export const TabLabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;
export const TabLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${G.slate500};
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
export const TabRefText = styled.span`
  font-size: 10.5px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const TabSepMeta = styled.span`
  font-size: 10.5px;
  color: ${G.slate400};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const DataRow = styled.tr`
  border-bottom: 1px solid ${G.slate100};
  transition: background 0.12s ease;
  background: ${({ $selected }) => ($selected ? "#EFF9FA" : G.white)};
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${({ $selected }) => ($selected ? "#E0F5F6" : "#f7fafb")};
  }
  &:hover td:first-child {
    box-shadow: inset 3px 0 0 ${G.teal};
  }

  td {
    padding: 11px 0; /* ← was 14px, tighter rows */
    vertical-align: middle;
  }
`;
export const EmptyRowTd = styled.td`
  padding: 26px 18px;
  text-align: center;
  font-size: 12.5px;
  color: ${G.slate400};
  font-style: italic;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const Checkbox = styled.input`
  width: 14px;
  height: 14px;
  cursor: pointer;
  accent-color: ${G.teal};
  border-radius: 3px;
`;
export const RefChip = styled.span`
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  color: ${G.navy};
  background: ${G.slate100};
  border: 1px solid ${G.slate200};
  padding: 3px 8px;
  border-radius: 5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
  letter-spacing: 0.3px;
`;
export const DocDescRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 280px;
`;
export const DocIconFrame = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid ${G.tealMid};
  background: ${G.tealLight};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const DocDescText = styled.div`
  font-size: 13px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  line-height: 1.4;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: ${G.teal};
  }
`;
export const DocDescMeta = styled.div`
  font-size: 11px;
  color: ${G.slate400};
  margin-top: 2px;
  font-family: ${theme.fonts.primaryFontRegular};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
export const DateText = styled.span`
  font-size: 12.5px;
  color: ${G.slate600};
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const MobileSfCards = styled.div`
  display: none;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  @media (max-width: 600px) {
    display: flex;
  }
`;
export const MobileEmpty = styled.div`
  padding: 16px;
  text-align: center;
  font-size: 12px;
  color: ${G.slate400};
  font-style: italic;
  font-family: ${theme.fonts.primaryFontRegular};
`;
export const MobileSfCard = styled.div`
  background: ${({ $selected }) => ($selected ? "#EFF9FA" : G.white)};
  border: 1px solid ${({ $selected }) => ($selected ? G.tealMid : G.slate200)};
  border-radius: 8px;
  padding: 13px;
  box-shadow: ${G.shadowSm};
  transition: box-shadow 0.15s;
  &:hover {
    box-shadow: ${G.shadowMd};
  }
`;
export const MobileSfCardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const MobileSfCardName = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: ${G.slate800};
  margin-bottom: 7px;
  font-family: ${theme.fonts.primaryFontRegular};
  cursor: pointer;
  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;
export const MobileSfCardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 7px;
  border-top: 1px solid ${G.slate100};
`;
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CtxWrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;
export const DotsBtn = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 7px;
  border: 1px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $open }) => ($open ? G.slate100 : "transparent")};
  transition: background 0.12s;
  &:hover {
    background: ${G.slate100};
    border-color: ${G.slate200};
  }
`;

export const DropMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 9999 !important;
  background: ${G.white};
  border: 1px solid ${G.slate200};
  border-radius: 10px;
  box-shadow: ${G.shadowLg};
  min-width: 190px;
  padding: 5px;
  animation: ${dropdownAnim} 0.15s ease;
  overflow: visible;
  @media (max-width: 520px) {
    min-width: 210px;
  }
`;
export const DropItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 11px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  text-align: left;
  font-size: 12px;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${({ $danger, $disabled }) =>
    $danger ? G.red : $disabled ? G.slate300 : G.slate700};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  transition: background 0.1s;
  &:hover {
    background: ${({ $danger }) => ($danger ? G.redLight : G.slate50)};
    color: ${({ $danger }) => ($danger ? G.redDark : G.slate800)};
  }
`;
export const DropDivider = styled.div`
  height: 1px;
  background: ${G.slate100};
  margin: 3px 0;
`;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: ${G.white};
  border-top: 1px solid ${G.slate200};
  flex-wrap: wrap;
  gap: 9px;
  flex-shrink: 0;
  @media (max-width: 640px) {
    padding: 9px 12px;
  }
`;
export const PaginationInfo = styled.div`
  font-size: 12px;
  color: ${G.slate500};
  font-family: ${theme.fonts.primaryFontRegular};
  strong {
    color: ${G.slate800};
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
`;
export const PaginationRight = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
`;
export const PageControls = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  flex-wrap: wrap;
`;
export const PageBtn = styled.button`
  padding: 4px 9px;
  font-size: 11.5px;
  font-weight: 600;
  border: 1px solid ${({ $active }) => ($active ? G.teal : G.slate200)};
  background: ${({ $active }) => ($active ? G.teal : G.white)};
  color: ${({ $active }) => ($active ? G.white : G.slate700)};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.12s;
  font-family: ${theme.fonts.primaryFontSemiBold};
  &:hover:not(:disabled) {
    border-color: ${G.teal};
    color: ${({ $active }) => ($active ? G.white : G.teal)};
    background: ${({ $active }) => ($active ? G.teal : G.tealLight)};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
export const PerPageSelect = styled.select`
  padding: 4px 7px;
  font-size: 11.5px;
  border: 1px solid ${G.slate200};
  border-radius: 6px;
  background: ${G.white};
  color: ${G.slate700};
  cursor: pointer;
  font-family: ${theme.fonts.primaryFontRegular};
  outline: none;
  &:hover,
  &:focus {
    border-color: ${G.teal};
  }
`;
export const Req = styled.span`
  color: ${G.red};
  margin-left: 2px;
`;

/* ── NEW styled components for new features ── */

/* FEATURE 4 — Bundle search bar */
export const BundleSearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${G.white};
  border: 1px solid ${G.slate200};
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 2px;
  box-shadow: 0 1px 2px rgba(41, 52, 97, 0.04);
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  &:focus-within {
    border-color: ${G.teal};
    box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.1);
  }
  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 12.5px;
    color: ${G.slate700};
    font-family: ${theme.fonts.primaryFontRegular};
    &::placeholder {
      color: ${G.slate400};
    }
  }
`;
export const SearchHighlight = styled.mark`
  background: #fef08a;
  color: ${G.slate800};
  border-radius: 2px;
  padding: 0 1px;
`;
export const NoResultsBanner = styled.div`
  text-align: center;
  padding: 14px 18px;
  font-size: 12.5px;
  color: ${G.slate500};
  background: ${G.slate50};
  border: 1px dashed ${G.slate300};
  border-radius: 9px;
  font-family: ${theme.fonts.primaryFontRegular};
  strong {
    font-family: ${theme.fonts.primaryFontSemiBold};
    color: ${G.slate700};
  }
`;

/* FEATURE 2 — Move document button */
export const MoveBtn = styled.button`
  background: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  padding: 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  transition: background 0.12s;
  opacity: ${({ disabled }) => (disabled ? 0.42 : 1)};
  &:hover:not(:disabled) {
    background: ${G.amberLight};
  }
  &:hover:not(:disabled) svg {
    stroke: ${G.amber};
  }
`;

/* FEATURE 2 — Move modal select */
export const SelectInput = styled.select`
  padding: 9px 13px;
  border-radius: 8px;
  font-size: 13px;
  border: 1.5px solid ${G.slate200};
  outline: none;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${G.slate800};
  background: ${G.slate50};
  cursor: pointer;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  &:focus {
    border-color: ${G.teal};
    box-shadow: 0 0 0 3px rgba(0, 131, 140, 0.12);
    background: ${G.white};
  }
`;
export const SidebarRenameInput = styled.input`
  flex: 1;
  min-width: 0;
  border: 1.5px solid ${G.teal};
  border-radius: 5px;
  padding: ${({ $small }) => ($small ? "2px 6px" : "3px 7px")};
  font-size: ${({ $small }) => ($small ? "10.5px" : "11.5px")};
  outline: none;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${G.slate800};
  background: ${G.white};
  box-shadow: 0 0 0 2px rgba(0, 131, 140, 0.1);
`;
export const QuickUploadBtn = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${G.tealMid};
  background: ${G.tealLight};
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
  &:hover {
    background: ${G.tealMid};
    border-color: ${G.teal};
  }
`;
export const EmptyRowUploadLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${G.teal};
  font-size: 12.5px;
  font-style: normal;
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

export const BundleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px 12px 22px;
  background: linear-gradient(135deg, #1e2a52 0%, #293461 100%);
  border-bottom: 1px solid ${G.slate200};
  gap: 12px;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  position: relative;
  min-height: 56px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: ${G.teal};
    border-radius: 8px 0 0 0;
  }
`;

export const BundleHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const BundleHeaderTop = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 0;
`;
export const BundleIdChip = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${G.white};
  font-family: ${theme.fonts.primaryFontSemiBold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
  letter-spacing: -0.2px;
`;

export const BundleTitle = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const BundleMeta = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
export const BundleStats = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
`;
export const BundleStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 5px 12px;
  min-width: 62px;
  gap: 1px;

  span {
    display: block;
    font-size: 8.5px;
    color: rgba(255, 255, 255, 0.45);
    font-family: ${theme.fonts.primaryFontRegular};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }

  strong {
    display: block;
    font-size: 16px;
    font-weight: 700;
    color: ${G.white};
    line-height: 1;
    font-family: ${theme.fonts.primaryFontSemiBold};
  }
`;
export const BundleHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;
